/* eslint-disable react/prop-types */
import Slider from "rc-slider"
import "rc-slider/assets/index.css"
import { RiskResidualItem } from "@/features/risks/entities/risk/model/risk.types"
import Chip from "./chip"
import getColor from "@/utils/get-color.utils"

type Props = {
  min?: number
  max: number
  scale: RiskResidualItem[] // [{min,max,label,color}, ...]
  onChange: (scale: RiskResidualItem[]) => void
  chipsOrientation?: "row" | "col" // chips à droite : row = côte à côte, col = empilées
}

export default function MultiThresholdSlider({ min = 1, max, scale, onChange, chipsOrientation = "row" }: Props) {
  const values = scale.slice(0, -1).map((s) => s.max)

  const handleChange = (vals: number[]) => {
    const [s1, s2, s3] = vals.sort((a, b) => a - b)

    const updated: RiskResidualItem[] = [
      { min, max: s1, label: "Faible", color: "green" },
      { min: s1 + 1, max: s2, label: "Modéré", color: "yellow" },
      { min: s2 + 1, max: s3, label: "Moyen", color: "orange" },
      { min: s3 + 1, max: max, label: "Élevé", color: "red" }
    ]

    onChange(updated)
  }

  // construit le dégradé à partir du scale
  const gradient = scale
    .map((s) => {
      const start = ((s.min - (min ?? 0)) / max) * 100
      const end = (s.max / max) * 100
      const color = getColor(s.color!)
      return `${color} ${start}% ${end}%`
    })
    .join(", ")

  return (
    <div className="w-full px-2 flex items-center gap-4">
      <div className="flex-1">
        <Slider
          range={{ minCount: 3 }}
          min={min}
          max={max}
          step={1}
          value={values}
          allowCross={false}
          pushable={1}
          onChange={(vals) => handleChange(vals as number[])}
          styles={{
            rail: {
              height: 10,
              borderRadius: 5,
              background: `linear-gradient(to right, ${gradient})`
            },
            track: {
              background: "transparent"
            },
            handle: {
              width: 16,
              height: 16,
              border: "2px solid #333",
              backgroundColor: "#fff",
              marginTop: -3,
              borderRadius: "50%",
              boxShadow: "0 0 2px rgba(0,0,0,0.3)"
            }
          }}
        />
      </div>

      <div className={`flex ${chipsOrientation === "col" ? "flex-col gap-2" : "flex-row gap-2 flex-wrap"}`}>
        {scale.map((s, i) => (
          <Chip key={i} color={getColor(s.color!)}>
            {s.label} : {s.min} - {s.max}
          </Chip>
        ))}
      </div>
    </div>
  )
}
